import React from 'react'
// img svg
import LocationPickerIcon from "../../assets/images/doctor/LocationPickerIcon.svg";

const Location = () => {
    return (
        <div className="d-flex justify-content-end align-items-center datapicker-border">
            <img
                className="pr-1 cursor-pointer"
                src={LocationPickerIcon}
                alt=""
            />
        </div>
    )
}

export default Location